{
  "MMM Do YYYY, h:mm a": "D MMM YYYY HH:mm",
  "MMM Do YYYY": "D MMM YYYY",
  "Wedding": "Bruiloft",
  "Funeral": "Uitvaart",
  "Birthday": "Verjaardag",
  "School": "School",
  "Sport": "Sport",
  "event type|Other": "Anders",
  "Audio/video professional": "Audio- en videoprofessional",
  "Funeral home owner or director": "Uitvaartondernemer of uitvaartleider",
  "Event planner or venue manager": "Evenementenplanner of locatiemanager",
  "Church, pastor, preacher or minister": "Kerk, pastor, predikant of voorganger",
  "Teacher or school manager": "Leraar of schoolleider",
  "Nonprofit or charity": "Goed doel of liefdadigheidsinstelling",
  "Live event streamer or producer": "Streamer of producent van live-evenementen",
  "role|Other": "Anders",
  "room noun|room": "zaal",
  "room noun|stage": "podium",
  "room noun|track": "baan",
  "room noun|court": "speelveld",
  "room noun|field": "veld",
  "room noun|hall": "hal",
  "room noun|camera": "camera",
  "Sorry, we need camera roll permissions to make this work!": "Sorry, we hebben toegang tot je foto's nodig om dit te laten werken.",
  "Streaming Permissions Required": "Toestemming nodig om te streamen",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "EventLive kan pas streamen als je toestemming geeft voor de camera, de microfoon en het opnemen.",
  "Search for an event": "Zoek een evenement",
  "Schedule your first service": "Plan je eerste dienst",
  "Create your first event": "Maak je eerste evenement aan",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Elke dienst krijgt een privélink om met de familie te delen. Families kijken op elk apparaat, zonder app of inloggen.",
  "It looks like you have no events at the moment. Create one to see it here": "Je hebt op dit moment nog geen evenementen. Maak er een aan, dan zie je het hier",
  "Schedule a Service": "Dienst plannen",
  "Create an Event": "Evenement aanmaken",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Je hebt {count} evenementcredit. Elke dag van een dienst kost er één.",
    "other": "Je hebt {count} evenementcredits. Elke dag van een dienst kost er één."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Je hebt {count} evenementcredit. Elke evenementdag kost er één.",
    "other": "Je hebt {count} evenementcredits. Elke evenementdag kost er één."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Je hebt {count} vooraf betaald evenement – dat gebruiken we voor dit evenement.",
    "other": "Je hebt {count} vooraf betaalde evenementen – we gebruiken er één voor dit evenement."
  },
  "Leave": "Verlaten",
  "Keep editing": "Verder bewerken",
  "Leave without scheduling the service?": "Verlaten zonder de dienst te plannen?",
  "Leave without scheduling the event?": "Verlaten zonder het evenement te plannen?",
  "Schedule your live fundraiser": "Plan je live-inzamelingsactie",
  "Schedule a service": "Plan een dienst",
  "Schedule your first event": "Plan je eerste evenement",
  "Schedule your event": "Plan je evenement",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Daarna bevestig je {organization} als de organisatie die de donaties ontvangt. Je kunt de details later wijzigen.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Daarna kies je de organisatie die de donaties ontvangt. Je kunt de details later wijzigen.",
  "The family gets one private link to watch live or later. You can change the details any time.": "De familie krijgt één privélink om live of later te kijken. Je kunt de details altijd wijzigen.",
  "You can change the details later.": "Je kunt de details later wijzigen.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "Weet je zeker dat je {title} en het bijbehorende podium wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende podia wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "Weet je zeker dat je {title} en de bijbehorende baan wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende banen wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "Weet je zeker dat je {title} en het bijbehorende speelveld wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende speelvelden wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "Weet je zeker dat je {title} en het bijbehorende veld wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende velden wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "Weet je zeker dat je {title} en de bijbehorende hal wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende hallen wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "Weet je zeker dat je {title} en de bijbehorende camera wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende camera's wilt verwijderen?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "Weet je zeker dat je {title} en de bijbehorende zaal wilt verwijderen?",
    "other": "Weet je zeker dat je {title} en de {count} bijbehorende zalen wilt verwijderen?"
  },
  "Could not delete event": "Het evenement kon niet worden verwijderd",
  "Are you sure you want to delete {title}?": "Weet je zeker dat je {title} wilt verwijderen?",
  "This action cannot be undone.": "Dit kan niet ongedaan worden gemaakt.",
  "Delete Event": "Evenement verwijderen",
  "Deleting Event...": "Evenement wordt verwijderd...",
  "Delete {camera}": "{camera} verwijderen",
  "How to Go Live": "Zo ga je live",
  "Guest List & Invite": "Gastenlijst en uitnodigen",
  "Title, Date, Time, Event Link, Uploads": "Titel, datum, tijd, evenementlink, bestanden",
  "Add Another Camera Angle": "Nog een camerahoek toevoegen",
  "Add a Room, Stage or Track": "Zaal, podium of baan toevoegen",
  "Chat": "Chat",
  "Privacy Settings": "Privacyinstellingen",
  "Event Branding": "Huisstijl van het evenement",
  "Event Analytics": "Evenementstatistieken",
  "Expiring soon": "Verloopt binnenkort",
  "Storage expiry": "Verloopdatum opslag",
  "You're invited to watch {title}": "Je bent uitgenodigd om {title} te bekijken",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Gasten gebruiken je hoofdlink en schakelen daar over op deze camera. Stream deze camera vanaf een aparte telefoon.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Deel deze link: gasten wisselen tijdens het kijken tussen de camera's. Elke camera streamt vanaf een eigen telefoon.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Gasten gebruiken de hoofdlink en wisselen van {noun} op de evenementpagina. Deze stream heeft een eigen streamsleutel.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Deel deze link: gasten wisselen van {noun} op de evenementpagina. Per {noun} stream je met een eigen streamsleutel.",
  "Your event link:": "Je evenementlink:",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "{days}-daags evenement: ontgrendelen met nog {count} credit",
    "other": "{days}-daags evenement: ontgrendelen met nog {count} credits"
  },
  "Unlock with {count} credit": {
    "one": "Ontgrendelen met {count} credit",
    "other": "Ontgrendelen met {count} credits"
  },
  "{days}-day event: Unlock with {count} prepaid events": "{days}-daags evenement: ontgrendelen met {count} vooraf betaalde evenementen",
  "{days}-day event: Unlock with your prepaid event": "{days}-daags evenement: ontgrendelen met je vooraf betaalde evenement",
  "Unlock with {count} prepaid events": "Ontgrendelen met {count} vooraf betaalde evenementen",
  "Unlock with your prepaid event": "Ontgrendelen met je vooraf betaalde evenement",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "Je privélink naar het evenement verloopt op {date}. Houd je evenementpagina, de video en het gastenboek nog 1 jaar langer online, of 10 jaar.",
  "Keep My Memories Online Longer": "Mijn herinneringen langer online houden",
  "Download & View Stats": "Downloaden en statistieken bekijken",
  "This Event is in the Secure Archive.": "Dit evenement staat in het beveiligde archief.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "De openbare streamingperiode van dit evenement is afgelopen. De streaminglink is verlopen, maar de herinneringen zijn veilig bewaard in ons archief.",
  "Restore this Event": "Dit evenement herstellen",
  "Unlock cameras": "Camera's ontgrendelen",
  "{days}-Day Event: {start} – {end}": "{days}-daags evenement: {start} – {end}",
  "Expires in {count} day": {
    "one": "Verloopt over {count} dag",
    "other": "Verloopt over {count} dagen"
  },
  "Event is in the Secure Archive": "Evenement staat in het beveiligde archief",
  "Extend": "Verlengen",
  "Use credit": "Credit gebruiken",
  "Use prepaid event": "Vooraf betaald evenement gebruiken",
  "Could not unlock the event": "Het evenement kon niet worden ontgrendeld",
  "Pay As You Go": "Betalen per gebruik",
  "Couldn't schedule the service": "De dienst kon niet worden gepland",
  "Couldn't schedule the event": "Het evenement kon niet worden gepland",
  "Service title": "Titel van de dienst",
  "e.g. Celebration of Life for Jane Doe": "bijv. Afscheidsdienst voor Ans de Vries",
  "e.g. Anna & Mark's wedding": "bijv. Bruiloft van Anna en Mark",
  "your-event-link": "jouw-evenement",
  "Available": "Beschikbaar",
  "Event type": "Soort evenement",
  "Choose the type of event": "Kies het soort evenement",
  "When the service starts": "Wanneer de dienst begint",
  "When the event starts": "Wanneer het evenement begint",
  "Make it a multi-day event": "Maak er een meerdaags evenement van",
  "Raise donations for a nonprofit": "Donaties inzamelen voor een goed doel",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Kijkers kunnen doneren op je evenementpagina. Je kiest de organisatie nadat het evenement is aangemaakt.",
  "Schedule service": "Dienst plannen",
  "Schedule event": "Evenement plannen",
  "Event details": "Details van het evenement",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} volgt de datum, tijd en dagen van het hoofdevenement. Wijzig ze daar; je hoeft ze niet per {noun} aan te passen.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "Wat je hier wijzigt, geldt voor het hele evenement. Extra dagen worden per {noun} in rekening gebracht.",
  "Title and location": "Titel en locatie",
  "Test events keep their name.": "Testevenementen houden hun naam.",
  "e.g. St. Mary's Church, Austin": "bijv. Sint-Mariakerk, Utrecht",
  "Links and files": "Links en bestanden",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Wordt onder de video op je evenementpagina getoond: een cadeaulijst, een donatiepagina, een website of een programma.",
  "Event rescheduled": "Evenement verplaatst",
  "Guests will see the new date.": "Gasten zien de nieuwe datum.",
  "Couldn't change the date": "De datum kon niet worden gewijzigd",
  "Event date and time": "Datum en tijd van het evenement",
  "Choose the event's local date and time": "Kies de lokale datum en tijd van het evenement",
  "Save date and time": "Datum en tijd opslaan",
  "Change Link": "Link wijzigen",
  "Change event link?": "Evenementlink wijzigen?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Als je de huidige link al met gasten hebt gedeeld, kunnen ze het evenement niet meer openen met de oude link. Weet je zeker dat je wilt doorgaan?",
  "Event link changed": "Evenementlink gewijzigd",
  "Couldn't change the link": "De link kon niet worden gewijzigd",
  "Share this link with your guests.": "Deel deze link met je gasten.",
  "your-event-name": "naam-van-je-evenement",
  "Copy event link": "Evenementlink kopiëren",
  "Guests who already have the old link won't be able to open the event with it.": "Gasten die de oude link al hebben, kunnen het evenement daarmee niet meer openen.",
  "Change link": "Link wijzigen",
  "Edit {title}": "{title} bewerken",
  "Edit link": "Link bewerken",
  "Add a name": "Voeg een naam toe",
  "Add a web address": "Voeg een webadres toe",
  "Open {title}": "{title} openen",
  "Open link": "Link openen",
  "Remove {title}": "{title} verwijderen",
  "Remove link": "Link verwijderen",
  "File name guests see": "Bestandsnaam die gasten zien",
  "Link text": "Linktekst",
  "e.g. Order of service": "bijv. Programma van de dienst",
  "e.g. Our registry": "bijv. Onze cadeaulijst",
  "Web address": "Webadres",
  "Add link": "Link toevoegen",
  "File added": "Bestand toegevoegd",
  "Guests can open it from the event page.": "Gasten kunnen het openen via de evenementpagina.",
  "Removed \"{title}\"": "“{title}” verwijderd",
  "Removed \"link\"": "Link verwijderd",
  "Tap to undo": "Tik om ongedaan te maken",
  "Uploading…": "Uploaden…",
  "Upload file": "Bestand uploaden",
  "file type|Text": "Tekst",
  "file type|Image": "Afbeelding",
  "file type|File": "Bestand",
  "Document": "Document",
  "Add the text guests will see.": "Voeg de tekst toe die gasten zien.",
  "Add the web address.": "Voeg het webadres toe.",
  "Enter an address like zola.com/registry or an email.": "Voer een adres in zoals zola.com/registry of een e-mailadres.",
  "Multi-Day event?": "Meerdaags evenement?",
  "Days": "Dagen",
  "Timezone: {timezone}": "Tijdzone: {timezone}",
  "Search timezone...": "Tijdzone zoeken...",
  "Select timezone": "Tijdzone kiezen",
  "MMMM D, yyyy h:mm a": "D MMMM YYYY HH:mm",
  "dddd, MMMM D, YYYY": "dddd D MMMM YYYY",
  "ddd, MMM D": "ddd D MMM",
  "Start Time": "Begintijd",
  "Event Date and Local Time": "Datum en lokale tijd van het evenement",
  "Event Date": "Datum van het evenement",
  "Select": "Selecteren",
  "date picker|Choose": "Kies",
  "date picker|Not available": "Niet beschikbaar",
  "date picker|Month": "Maand",
  "date picker|Previous Month": "Vorige maand",
  "date picker|Next Month": "Volgende maand",
  "EEEE, MMMM d, yyyy": "EEEE d MMMM yyyy",
  "Start time": "Begintijd",
  "h:mm aa": "HH:mm",
  "date picker|time": "Tijd",
  "MMMM d, yyyy h:mm aa": "d MMMM yyyy HH:mm",
  "EEE, MMM d": "EEE d MMM",
  "Hide the event page? Guests won't be able to open it.": "Evenementpagina verbergen? Gasten kunnen de pagina dan niet openen.",
  "Hide the event page?": "Evenementpagina verbergen?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Mensen die een ticket hebben gekocht, kunnen de livestream en de opname niet bekijken tot je de pagina weer zichtbaar maakt. {count} persoon op je gastenlijst verliest de toegang.",
    "other": "Mensen die een ticket hebben gekocht, kunnen de livestream en de opname niet bekijken tot je de pagina weer zichtbaar maakt. {count} mensen op je gastenlijst verliezen de toegang."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Mensen die een ticket hebben gekocht, kunnen de livestream en de opname niet bekijken tot je de pagina weer zichtbaar maakt.",
  "{days}-Day Event: {start}": "{days}-daags evenement: {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "Dit evenement is nog niet ontgrendeld. Vraag een beheerder van het account van {team} om het te ontgrendelen.",
  "Couldn't load {team}'s events. Try again.": "De evenementen van {team} konden niet worden geladen. Probeer het opnieuw.",
  "Switch to my account": "Overschakelen naar mijn account",
  "No events yet": "Nog geen evenementen",
  "Events in {team}'s account will show up here.": "Evenementen in het account van {team} verschijnen hier.",
  "Event unlocked": "Evenement ontgrendeld",
  "Couldn't unlock this event": "Dit evenement kon niet worden ontgrendeld",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Het account van {team} heeft misschien niet genoeg credits. Vraag de accounthouder om er meer toe te voegen."
}
